import { render, staticRenderFns } from "./OrderNavigationDrawer.vue?vue&type=template&id=37e4ea90&scoped=true&"
import script from "./OrderNavigationDrawer.vue?vue&type=script&lang=js&"
export * from "./OrderNavigationDrawer.vue?vue&type=script&lang=js&"
import style0 from "./OrderNavigationDrawer.vue?vue&type=style&index=0&id=37e4ea90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e4ea90",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VDialog,VItem,VItemGroup,VSpacer})
